module.exports = __webpack_public_path__ + "static/media/login.38d72158.svg";